import { TFunction } from "i18next";
import { TFuncKey } from "../../../i18n";
import {
    cardContentStyles,
    cardStyles,
    setUpSignInMethodBlockStyles,
    setUpSignMethodDesc,
    setUpSignMethodWrapperStyles,
    StyledSetUpTypography
} from "../styles";
import Card from "../../../components/card/Card";
import { Box, Typography } from "@mui/material";
import Button from "../../../components/button/Button";
import { CredentialContainer } from "../../../api/representations";


interface SetupPersonalMethod {
    t: TFunction;
    category: string;
    container: CredentialContainer;
    resourceUrl: string;
    redirectToAttach: () => void;
}

export default function SetupPersonalMethod({t, category, container, resourceUrl, redirectToAttach}: SetupPersonalMethod) {
    return (
        <Card key={container.category} title={t(category as TFuncKey)} sxContent={cardContentStyles} sxCard={cardStyles}>
            <Box sx={setUpSignInMethodBlockStyles}>
              <Box sx={setUpSignMethodWrapperStyles}>
                <img src={`${resourceUrl}/images/signIn_grey.svg`} alt={t('signingIn')} />
                <StyledSetUpTypography>{t('personalSignIn')}</StyledSetUpTypography>
                <Typography variant="body2" sx={setUpSignMethodDesc} color="secondary">{t('setUpSignInMethod')}</Typography>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => redirectToAttach()}
                  data-testid={`${container.type}/create`}
                >
                  {t("setUpNew", {name: ''})}
                </Button>
              </Box>
            </Box>
        </Card>
    );
}